import { render } from "./CRMWhatsappMarketingCampaignDialog.vue?vue&type=template&id=332197cc&scoped=true"
import script from "./CRMWhatsappMarketingCampaignDialog.vue?vue&type=script&lang=js"
export * from "./CRMWhatsappMarketingCampaignDialog.vue?vue&type=script&lang=js"

import "./CRMWhatsappMarketingCampaignDialog.vue?vue&type=style&index=0&id=332197cc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-332197cc"]])

export default __exports__